import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ContractorRoutes } from 'routes';
import { TheraAdvanceTransactionType } from 'lib/constants';
import { TransactionTypeFilter, UnifiedTransaction } from 'utils/unifiedTransactions';

export const useUnifiedTabState = (defaultType: TransactionTypeFilter, availableTypes: TransactionTypeFilter[]) => {
  const router = useRouter();
  const [selectedType, setSelectedType] = useState<TransactionTypeFilter>(defaultType);

  useEffect(() => {
    const tab = router.query.selectedTab as TransactionTypeFilter;
    if (tab && availableTypes.includes(tab)) setSelectedType(tab);
  }, [router.query.selectedTab, availableTypes]);

  const handleTypeChange = (val: TransactionTypeFilter) => {
    setSelectedType(val);
    router.replace({ query: { ...router.query, selectedTab: val } }, undefined, { shallow: true });
  };

  const handleUnifiedRowClick = (row: UnifiedTransaction) => {
    if (row.type === 'withdrawals' && row.ledgerTransactionId) {
      router.push(ContractorRoutes.WithdrawalInfo.replace('[withdrawalID]', row.ledgerTransactionId));
    } else if (row.type === 'thera_advance_withdrawal' || row.type === 'thera_advance_repayment') {
      const type =
        row.type === 'thera_advance_withdrawal'
          ? TheraAdvanceTransactionType.WITHDRAWAL
          : TheraAdvanceTransactionType.REPAYMENT;
      router.push(`/thera-advance/${row.id}?type=${type}`);
    }
  };

  return { selectedType, handleTypeChange, handleUnifiedRowClick };
};
